import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmPopoverTitle]',
  host: { 'data-slot': 'popover-title', class: 'ocp-spartan-scope' },
})
export class HlmPopoverTitle {
  constructor() {
    classes(() => 'font-medium');
  }
}
